var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconScreenshareTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.914 7c.6 0 1.086.488 1.086 1.088v6.552c0 .6-.485 1.087-1.086 1.087h-4.369v1.091h2.724c.282 0 .514.21.545.482l.004.064a.547.547 0 0 1-.55.545H8.732a.546.546 0 1 1 0-1.09h2.724v-1.092H7.086c-.6 0-1.086-.488-1.086-1.087V8.088C6 7.488 6.485 7 7.086 7h9.829-.001zm-.005 1.09H7.091v6.546h9.818V8.091z",
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 0.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScreenshareTitle);
export default __webpack_public_path__ + "static/media/icon-screenshare-title.32192838.svg";
export { ForwardRef as ReactComponent };